/*global ViewController, WebView, moment, TemplateController, Handlebars*/

var pkg = require("../../../package.json") ;

var mainController = new ViewController({
    directory : "views/main",
    name: "main_v2",
    container: "main",
    route: "" //displayed by default (no route)
}) ;

mainController._socketNotifRegistered = false;
mainController.notificationListener = function(){
    if(mainController._socketNotifRegistered){ return; }
    mainController._socketNotifRegistered = true;

    this.api.socket.on("notif-link-send", function(ev) {
        if(this.api && this.api.currentUser && (ev.user_id && ev.user_id === this.api.currentUser.id)) {
            this.api.db.multiread({
                linkSendCount: {
                    table: "iz_link_send",
                    search: {
                        user_id: this.api.currentUser.id,
                        state: ["send", "received"],
                        create_date: {ope:">", value: moment().subtract(1, "month").toDate()}
                    },
                    groupBy: "state",
                    operations: [{ope: "count"}]
                }
            }, function(err, reads) {
                if(err) {
                    if(err === "NOT_CONNECTED") {
                        return;
                    }
                    console.error("Error update send links", err);
                    return;
                }

                this.data.linkSendCount = 0;
                this.data.linkSendCountNew = 0;
                reads.linkSendCount.forEach(function(n) {
                    if(n.state === "send") {
                        this.data.linkSendCountNew += Number(n.count);
                    }
                    this.data.linkSendCount += Number(n.count);
                }.bind(this));
                this.view.render();
            }.bind(this));
        }
    }.bind(this));

    this.api.socket.on('notif-change',  function(ev){
        if(this.api && this.api.currentUser && (!ev.user_id || ev.user_id === this.api.currentUser.id)){
            this.api.db.multiread({
                notifsCount: {
                    table: "iz_notification", 
                    search: {
                        real_user_id: this.api.currentUser.id, 
                        state: ["new", "view", "sent"],
                        date: {ope:"between", value: [moment().subtract(1, "month").toDate(), new Date()]}
                    }, 
                    groupBy: "state",
                    operations: [{ope: "count"}],
                }
            }, function(err, reads){
                if(err){ 
                    if(err === "NOT_CONNECTED"){
                        return;
                    }
                    console.log("Error update notifications", err) ;
                    return ;
                }
    
                this.data.notifsCount = 0;
                this.data.notifsCountNew = 0;
                reads.notifsCount.forEach(function(n){
                    if(n.state === "new" || n.state === "sent"){
                        this.data.notifsCountNew += Number(n.count);
                    }
                    this.data.notifsCount += Number(n.count);
                }.bind(this)) ;

                this.view.render() ;
            }.bind(this)) ;
        }
    }.bind(this));
} ;

mainController.computeMenuCounts = function(menuEntries, callback){
    let calls = [] ;
    menuEntries.forEach(function(menu){
        menu.entries.forEach(function(entry){
            if(entry.countSearch){
                calls.push(function(cb){
                    this.api.db.multiread({
                        count: entry.countSearch
                    }, function(err, reads){
                        if(err){ return cb(err) ;}
                        if(reads.count && reads.count.length>0){
                            entry.entryCount = Number(reads.count[0].count||0) ;
                        }else{
                            entry.entryCount = 0 ;
                        }
                        cb() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }
        }.bind(this)) ;
    }.bind(this)) ;
    WebView._asyncSeries(calls, callback) ;
} ;

mainController.onRender = function(){
    if(this.renderingCount){ return ; }
    mainController.computeMenuCounts(this.data.menuEntries, function(err){
        if(err){ return console.log("error", err) ; }
        this.renderingCount = true ;
        this.view.render() ;
        setTimeout(function(){
            this.renderingCount = false ;
        }.bind(this), 1000) ;
    }.bind(this)) ;
} ;
/* test widget freshdesk
mainController.onDisplayed = function(){
    if(!window.fwSettings){
        window.fwSettings={
        'widget_id':101000007111
        };
        !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}() 
    }
    scriptLoader.load({
        name: "freshdesk",
        type: "js",
        cdn: "https://euc-widget.freshworks.com/widgets/101000007111.js"
    }, function(err){
        if(!err){
            FreshworksWidget('hide', 'launcher');
        }
    }) ;
//<script type='text/javascript' src='https://euc-widget.freshworks.com/widgets/101000007111.js' async defer></script>
} ;
*/

function testRights(rights){
    if(!rights){ return true ;}
    rights = rights.split(/\s/).map(function(w){
        if(w === "&&" || w === "||" || w === "(" || w === ")"|| w === "!"){ return w ;}
        if(w.startsWith("!")){
            return "!user.rights."+w.replace("!", "") ;
        }else{
            return "user.rights."+w ;
        }
    }).join(" ") ;
    return new Function("user", "return "+rights)(window.app.context.api.currentUser||{rights:{}}) ;
}
mainController.prepareDataOnEnter = function(data, callback){
    mainController.notificationListener() ;
    //Get menu entries from modules (defined in registerModule)

    let jsonUserStr = null;
    let jsonUserRegexp = null;
    if(this.api.currentUser){
        jsonUserStr = encodeURIComponent(JSON.stringify({
            user: this.api.currentUser.id,
        }).replace("{", "").replace("}", "")) ;
        jsonUserRegexp = new RegExp(jsonUserStr.replace(""+this.api.currentUser.id, "\\d+")) ;
    }

    this.api.db.multiread({
        iz_customized_menu: {
            search: {
                $or: [
                    { user_id: null },
                    { user_id: this.api.currentUser?this.api.currentUser.id:0 },
                ]
            },
            joins: [
                { otherTable: "iz_customized_menu_section", type: "2many", name: "sections", orderBy: "sequence", joins: [
                    {otherTable: "iz_customized_menu_entry", type: "2many", name: "entries",  orderBy: "sequence",}
                ]}
            ]
        }
    }, (err, reads)=>{
        if(err){ 
            reads = {iz_customized_menu : [] }; //don't fail if not connected
        }

        let userMenu = reads.iz_customized_menu.find(m=>this.api.currentUser && m.user_id === this.api.currentUser.id) ;
        let globalMenu = reads.iz_customized_menu.find(m=>m.user_id === null) ;

        let customizedMenu = userMenu || globalMenu ;
        
        var menuEntries = [] ;
        if(customizedMenu){
            for(let section of customizedMenu.sections){
                section.id = section.code ;
                section.position = section.sequence;
                menuEntries.push(section) ;
            }
        }
        menuEntries = menuEntries.filter(me=>window.APP_MODULES.some(mo=>mo.name === me.module)) ;
        var menuQuicks = [] ;
        var calls = [] ;
        window.APP_MODULES.forEach(function(module){
            var menu = module.menu ;
            if(menu){
                if(typeof(menu) !== "function"){
                    menu = function(callback){
                        callback(null, module.menu) ;
                    } ;
                }
                calls.push(function(cb){
                    menu(function(err, menuOfModule){
                        if(err){ return cb(err) ;}
                        
                        if(!menuOfModule){ return cb();}
                        
                        if(!Array.isArray(menuOfModule)){
                            menuOfModule = [menuOfModule] ;
                        }

                        menuOfModule = menuOfModule.filter(m=>testRights(m.rights));
    
                        module.computedMenu = menuOfModule;
    
                        menuOfModule.forEach(function(m){
                            if(!m.id){
                                m.module = module.name;
                                menuEntries.push(m) ;
                            }else{
                                if(!menuEntries.some(function(em){
                                    if(em.id === m.id){

                                        if(!em.entries){
                                            em.entries = [] ;
                                        }

                                        for(let e of m.entries){
                                            
                                            let existingEntry = em.entries.find(ex=>ex.url.replace(jsonUserRegexp, jsonUserStr) === e.url.replace(jsonUserRegexp, jsonUserStr)) ;
                                            if(existingEntry){
                                                existingEntry.icon = e.icon ; //always take right from app
                                                existingEntry.color = e.color ; //always take right from app
                                                existingEntry.countSearch = e.countSearch ; //always take countSearch from app
                                                existingEntry.countStyle = e.countStyle ; //always take right from app
                                                existingEntry.url = e.url ;//in case in contains the user
                                                existingEntry.standardFound = true ;
                                                if(e.rights){
                                                    if(existingEntry.rights){
                                                        existingEntry.rights = "( "+existingEntry.rights + " || "+e.rights+" )" ;
                                                    }else{
                                                        existingEntry.rights = e.rights ; //always take right from app
                                                    }
                                                }
                                            }else{
                                                if(!e.is_standard){
                                                    em.entries.push(e) ;
                                                }
                                            }
                                        }

                                        Object.keys(m).forEach(function(k){
                                            if(k !== "entries" && em[k] === undefined){
                                                em[k] = m[k] ;
                                            }
                                        }) ;
                                        return true;
                                    }
                                })){
                                    m.module = module.name;
                                    menuEntries.push(m) ;
                                }
                            }
                        }) ;
                        cb() ;
                    }) ;
                }) ;
            }
    
            var menuQuick = module.menuQuick ;
            if(menuQuick){
                if(!Array.isArray(menuQuick)){
                    menuQuick = [menuQuick] ;
                }
                menuQuick.forEach(function(m){
                    menuQuicks.push(m) ;
                }) ;
            }
        }) ;
    
        WebView._asyncSeries(calls, function(err){
            if(err){ return callback(err) ;}
    
    
    
            menuQuicks = menuQuicks.sort(function(m1, m2){
                return m1.position - m2.position;
            }) ;
        
            menuEntries = menuEntries.sort(function(m1, m2){
                return m1.position - m2.position;
            }) ;
        
            menuEntries.forEach(function(me){
                if(!me.entries){ return ;}
                me.entries = me.entries.filter(function(e){
                    if(e.hide){ return false ;}
                    if(e.is_standard && !e.standardFound){ return false; }
                    return testRights(e.rights) ;
                }.bind(this));
            }.bind(this));
    
    
            menuEntries = menuEntries.filter(function(me){
                return me.url || (me.entries && me.entries.length > 0) ;
            }) ;
    
            menuQuicks = menuQuicks.filter(function(e){
                if(!e.rights){ return true ;}
                var rights = e.rights.split(/\s/).map(function(w){
                    if(w === "&&" || w === "||" || w === "(" || w === ")"|| w === "!"){ return w ;}
                    if(w.startsWith("!")){
                        return "!user.rights."+w.replace("!", "") ;
                    }else{
                        return "user.rights."+w ;
                    }
                }).join(" ") ;
                return new Function("user", "return "+rights)(this.api.currentUser||{rights:{}}) ;
            }.bind(this));
        
        
            var activatedQuicks = [];
            if(this.api.currentUser && this.api.currentUser.iz_menu_quick){
                activatedQuicks = this.api.currentUser.iz_menu_quick.split(",");
            }
        
            menuQuicks = menuQuicks.filter(function(e){
                return activatedQuicks.indexOf(e.id) !== -1 ;
            }.bind(this));
    
            var data = {
                showFavorites: true,//menuEntries.length>3,
                menuEntries: menuEntries,
                menuQuicks: menuQuicks,
                user: this.api.currentUser,
                pinMenu: this.api.currentUser?this.api.currentUser.iz_pin_menu:false
            } ;

            window.app.context.menuEntries = menuEntries ;
    
            if(!this.api.currentUser){
                return callback(null, data) ;
            }
        
            this.api.db.multiread({
                linkSendCount: {
                    table: "iz_link_send",
                    search: {
                        user_id: this.api.currentUser.id,
                        state: ["send", "received"],
                        create_date: {ope:">", value: moment().subtract(1, "month").toDate()}
                    },
                    groupBy: "state",
                    operations: [{ope: "count"}]
                },
                notifsCount: {
                    table: "iz_notification", 
                    search: {
                        real_user_id: this.api.currentUser.id, 
                        state: ["new", "view", "sent"],
                        date: {ope:"between", value: [moment().subtract(1, "month").toDate(), new Date()]}
                    }, 
                    groupBy: "state",
                    operations: [{ope: "count"}],
                },
                iz_global_settings: { 
                    searchFirst: {},
                    joinFetch: [
                        { otherTable: "ir_attachment", type: "2one", name: "attach", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.global.settings"}}
                    ]
                },
                iz_custom_menu: {
                    search: {
                        user_id: this.api.currentUser.id, 
                    },
                },
                iz_custom_screen: {
                    search: { active: true , type: ["grid", "form", "gridAndForm", "view"] },
                },
                iz_package: { 
                    search: {
                        $or: [
                            { date_to: null},
                            { date_to: {ope: ">", value: moment().format("YYYY-MM-DD")} },
                        ]
                    }, 
                    orderBy: "date_from, id" 
                }
            }, function(err, reads){
                if(err){ 
                    if(err === "NOT_CONNECTED"){
                        return callback(null, data) ;
                    }
                    return callback(err) ;
                }

                data.hasOffice365Token = false;
                if (this.api.currentUser && this.api.currentUser.iz_office365_login) {
                    data.hasOffice365Token = true;
                }
    
                reads.iz_custom_screen.forEach(function(screen){
                    try{
                        var controllerCode = "custom_"+screen.code ;
                        let customScreenController = window.app.context.controllers[controllerCode] ;
                        if(customScreenController){
                            let route;
                            if(customScreenController.viewOptions && customScreenController.viewOptions.route){
                                route = customScreenController.viewOptions.route ;
                            }else if(customScreenController.options.grid && customScreenController.options.grid.route ){
                                route = customScreenController.options.grid.route;
                            }
                            if(screen.menu){
                                data.menuEntries.some(function(m){
                                    if(m.id === screen.menu){
                                        m.entries.push({
                                            label: screen.name,
                                            url: "#"+route
                                        }) ;
                                        return true;
                                    }
                                }) ;
                            }
                        }
                    }catch(err){
                        console.error("Error while init screen", screen, err) ;
                    }
                }.bind(this)) ;
    
                data.linkSendCount = 0;
                data.linkSendCountNew = 0;
                reads.linkSendCount.forEach(function (n) {
                    if (n.state === "send") {
                        data.linkSendCountNew += Number(n.count);
                    }
                    data.linkSendCount += Number(n.count);
                }.bind(this));
    
                data.notifsCount = 0;
                data.notifsCountNew = 0;
                reads.notifsCount.forEach(function(n){
                    if(n.state === "new" || n.state === "sent"){
                        data.notifsCountNew += Number(n.count);
                    }
                    data.notifsCount += Number(n.count);
                }) ;
                data.globalSettings = reads.iz_global_settings||{} ;
                if(data.globalSettings && data.globalSettings.name){
                    document.endOfTitle = data.globalSettings.name ;
                }
                document.title = WebView.tr("global.appName");
                data.favEntries = reads.iz_custom_menu ;
                data.packageInfo = pkg ;
                data.packageInfo.build = data.packageInfo.version.substring(data.packageInfo.version.lastIndexOf(".")+1) ;
                data.packageInfo.hostname = window.app.context.hostname ;
    
                data.dashboardLink = "#dashboard" ;
                var modulesRights = Object.keys(this.api.currentUser.rights).filter(function(r){return /module_user$/.test(r) ;}) ;
                if(modulesRights.length === 1 && modulesRights[0] === "group_iz_dinvoice_module_user" && this.api.currentUser.rights.group_iz_dinvoice_customer_user){
                    data.noDashboard = true ;
                    data.showFavorites = false ;
                    data.dashboardLink = "#!dinvoice-main#dinvoice-dashboard" ;
                }
    
                if(!reads.iz_global_settings || !reads.iz_global_settings.attach){
                    return callback(null, data) ;
                }
                
                if(data.globalSettings && data.globalSettings.url){
                    this.view.ensureDisplayed(function(){
                        const element = document.querySelector(".qr-code") ;
                        if(!element){ return ; }
                        new window.QRious({
                            foreground: '#777',
                            size: 150,
                            element: element,
                            value: location.href,
                        }) ;
                    }) ;
                }

                data.hasInvoicingDashboard = reads.iz_package.some(pkg=>pkg.pkg.consume.monthly.filter(m=>{
                    return this.api.currentUser && this.api.currentUser.rights[m.rights] ;
                }).length>0) ;

                return callback(null, data) ;
    
                // var logoAttach = reads.iz_global_settings.attach ;
    
                // var extension = "";
                // if(logoAttach.datas_fname.indexOf(".") !== -1){
                //     extension = logoAttach.datas_fname.substring(logoAttach.datas_fname.lastIndexOf(".")) ;
                // }
                // var filename = "logo"+extension;
                // this.api.readBinary.url(logoAttach, filename, function(err, url){
                //     if(err){ 
                //         console.log("Can't get image") ;
                //     }else{
                //         data.logoUrl = url ;
                //     }
                //     return callback(null, data) ;
                // }) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }) ;


} ;

mainController.onPinClicked = function(ev){
    if(this.api.currentUser.iz_pin_menu === null){
        this.api.currentUser.iz_pin_menu = true;
    }else{
        this.api.currentUser.iz_pin_menu = !this.api.currentUser.iz_pin_menu;     
    }
    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            {
                table: "res_users",
                action: "update",
                record: {
                    id: this.api.currentUser.id,
                    iz_pin_menu: this.api.currentUser.iz_pin_menu
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            this.view.user = this.api.currentUser ;
            this.enter() ;
            done() ;
        }.bind(this));
    }.bind(this));
} ;

mainController.onMenuClicked = function(ev){
    this.navigate(ev.data.replace(/^#/, "/")) ;
    if(this.view.closeTopMenus){ this.view.closeTopMenus() ; }
};

mainController.onLogout = function(){
    this.view.longTask(function(done){
        this.api.auth.logout(function(err){
            if(err){ return done(err);}
            this.navigate("/") ;
            mainController.refresh() ;
            done() ;
            document.location.reload() ;
        }.bind(this)) ;
    }.bind(this));
} ; 

mainController.onUserPref = function(){
    this.navigate("~user-prefs") ;
} ;

mainController.onQuickEntry = function(ev){
    this.navigate(ev.data.data.url) ;
} ;

mainController.onNotifySendlinks = function(){
    this.navigate("~notifyLinkSend", {linkSend: window.location.href}) ;
} ;

mainController.onNotifications = function(ev){
    this.navigate("~notifications") ;
} ;

mainController.on("initView", () => {
    mainController.appController.on("userPrefSaved", function(){
        mainController.refresh() ;
    }) ;

    function getViewRoot(el){
        let viewRoot = el.closest("[data-viewname]") ;
        if(viewRoot){
            let viewName = viewRoot.getAttribute("data-viewname") ;
            if(viewName.endsWith("/undefined") || viewName.endsWith("/null")){
                if(!viewRoot.parentElement){ return null; }
                return getViewRoot(viewRoot.parentElement);
            }else{
                return viewRoot;
            }
        }
        return null;
    }
    document.addEventListener("click", (ev) => {
        if(ev.target){
            let parentElWithId = ev.target.closest("[data-original-id]") ;
            if(parentElWithId && parentElWithId.tagName === "BUTTON"){
                let idClicked = parentElWithId.getAttribute("data-original-id");            
                let viewRoot = getViewRoot(ev.target) ;
                if(viewRoot){
                    const viewName = viewRoot.getAttribute("data-viewname") ;
                    if(!window.localStorage.getItem('iz_click_tracking')) {
                        window.localStorage.setItem('iz_click_tracking', JSON.stringify([]));
                    }
                    try {
                        const trackingClicks = JSON.parse(window.localStorage.getItem('iz_click_tracking'));
                        trackingClicks.push({
                            url: window.location.href,
                            view_name: viewName,
                            element_id: idClicked,
                            date_click: new Date().toISOString()
                        });
                        if(trackingClicks.length >= 20) {
                            const records = [];
                            for (let click of trackingClicks) {
                                records.push({
                                    table: 'iz_click_tracking',
                                    action: 'insert',
                                    record: {
                                        ...click
                                    }
                                });
                            }
                            window.localStorage.setItem('iz_click_tracking', JSON.stringify([]));
                            mainController.api.db.transactionalChanges(records, err => {
                                if(err) {
                                    return console.log(err);
                                }
                            });
                        } else {
                            window.localStorage.setItem('iz_click_tracking', JSON.stringify(trackingClicks));
                        }
                    } catch (err) {
                        console.log('saving click tracking error: ', err);
                    }
                }
            }
        }
    }) ;
}) ;

mainController.onChangePassword = function(){
    this.view.longTask(function(done){
        var viewChange = new WebView("views/main", "changePassword") ;
        viewChange.openInPopup({
            title: WebView.tr("main.changePassword")
        }, function(){
            done() ;
        }.bind(this))  ;
        viewChange.on("cancel",function(){
            viewChange.close() ;
        }.bind(this)) ;
        viewChange.on("validate",function(){
            var data = viewChange.getData() ;
            this.api.auth.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                if(err){ return done(err);}
                if(!success){
                    return done(WebView.tr("main.wrongPassword")) ;
                }
                viewChange.close() ;
                WebView.info(WebView.tr("main.changePasswordSuccess"), done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

mainController.onMenuAddToFav = function(){
    var viewData = JSON.parse(JSON.stringify(window.currentView.getBoundObject())) ;
    var currentHash = window.location.hash ;
    var name = "" ;
    let titleEl = document.querySelector(".crumb-current-title") ;
    if(titleEl){
        name = titleEl.innerText ;
    }
    const currentActiveRoutes = window.app._getRoutes(window.location.hash) ;
    const currentController = currentActiveRoutes[currentActiveRoutes.length - 1].def.controller ;

    let isGridScreen = currentController.getCriteriasFromFields ;
    var fav = {
        name: name,
        user_id: this.api.currentUser.id,
        url: currentHash,
        custom_filter_id: (viewData.customFilter && viewData.customFilter.id) ? viewData.customFilter.id : null,
        isGridScreen: isGridScreen
    } ;
    this.view.longTask(function(done){
        var viewAdd = new WebView("views/main", "addFavMenu") ;
        viewAdd.openInPopup({
            data: fav
        }, function(){
            done() ;
        }.bind(this))  ;
        viewAdd.on("cancel",function(){
            viewAdd.close() ;
        }.bind(this)) ;
        viewAdd.on("validate",function(){
            viewAdd.updateData() ;

            const currentActiveRoutes = window.app._getRoutes(window.location.hash) ;
            const currentController = currentActiveRoutes[currentActiveRoutes.length - 1].def.controller ;

            if (currentController.getCriteriasFromFields && fav.save_filter) {
                fav.filter_json = {} ;
                fav.filter_json.criterias = currentController.getCriteriasFromFields() ;
                fav.filter_json.state_filters = currentController.getSearchFilters() ;
                fav.filter_json.table_filters = currentController.view.EL[currentController.table+"Grid"].getGridApi().getFilterModel() ;
                fav.filter_json.column_states = currentController.view.EL[currentController.table+"Grid"].getGridColumnApi().getColumnState() ;
            }

            this.view.longTask(function(done){
                this.api.db.transactionalChanges([
                    { table: "iz_custom_menu", record: fav }
                ], function(err){
                    if(err){ return done(err);}
                    viewAdd.close() ;
                    mainController.refresh(done) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

mainController.onMenuSubEntryFav = async function(ev){
    const entryFav = ev.data.data ;
    let reads;
    if(entryFav.custom_filter_id) {
        reads = await this.apip.db.multiread({
            iz_custom_filter: { 
                    searchFirst: { 
                        id: entryFav.custom_filter_id, 
                    },
                    joinFetch: [
                    { otherTable : "iz_custom_filter_column", name: "lines", type:"2many"}
                ]
            }
        }) ;
        window.app.context.customFilter = reads.iz_custom_filter ;
    }
    if (entryFav.save_filter) {
        window.app.context.bookmarkFilter = entryFav.filter_json ;
    }
    function applyBookmarkFilter(){
        const currentActiveRoutes = window.app._getRoutes(window.location.hash) ;
        if(currentActiveRoutes){
            const currentController = currentActiveRoutes[currentActiveRoutes.length - 1].def.controller ;
            console.log('apply bookmark: ', currentController);
            if(currentController && currentController.applyBookmarks){
                currentController.applyBookmarks() ;
                currentController.refresh();
            }else{
                delete  window.app.context.bookmarkFilter ;
                delete window.app.context.customFilter;
            }
        }else{
            delete  window.app.context.bookmarkFilter ;
            delete window.app.context.customFilter;
        }
    }
    if(window.location.hash !== entryFav.url){
        this.navigate(entryFav.url.replace(/^#!/, "/"));
        if(this.view.closeTopMenus){ this.view.closeTopMenus() ; }
    }else{
        applyBookmarkFilter();
    }
    
    
    
} ;

mainController.onRemoveFav = function(ev){
    this.view.confirm(WebView.tr("main.removeFavConfirm"), function(yes){
        if(yes){
            var fav = ev.data.data ;
            this.view.longTask(function(done){
                this.api.db.transactionalChanges([
                    { table: "iz_custom_menu", action: "remove", record: fav }
                ], function(err){
                    if(err){ return done(err);}
                    mainController.refresh(done) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
} ;

mainController.onCancelFieldAdmin = function(){
    $(document.body).removeClass("adding-field") ;
};

mainController.onAddFieldAdmin = function(){
    $(document.body).addClass("adding-field") ;
    var clickListener = function(ev){
        var fieldName = null;
        var screenType = null;
        var table = window.currentView.table;
        if(ev.target.hasAttribute("col-id") || $(ev.target).closest("[col-id]").length>0){
            var fieldTarget = ev.target ;
            screenType = "grid";
            if(!ev.target.hasAttribute("col-id")){
                fieldTarget = $(ev.target).closest("[col-id]")[0] ;
            }
            fieldName = fieldTarget.getAttribute("col-id") ;
        } else if(ev.target.hasAttribute("data-field-def") || $(ev.target).closest("[data-field-def]").length>0){
            var fieldTarget = ev.target ;
            screenType = "form";
            if(!ev.target.hasAttribute("data-field-def")){
                fieldTarget = $(ev.target).closest("[data-field-def]")[0] ;
            }
            fieldName = fieldTarget.getAttribute("data-field-def") ;
            if($(ev.target).closest("[data-line-input]").length>0){
                screenType = "formTable";
                table = fieldName.split(".")[0] ;
            }
        }
        if(fieldName){
            $(document.body).removeClass("adding-field") ;
            
            this.navigate("~add-custom-field-popup", {
                view: window.currentView.directory+"/"+window.currentView.name,
                table: table,
                fieldName: fieldName,
                screenType: screenType,
            });
            ev.preventDefault() ;
            ev.stopPropagation() ;
            document.removeEventListener("click", clickListener) ;
        }
    }.bind(this) ;
    document.addEventListener("click", clickListener) ;
};

mainController.onViewInfoView = function(){
    var viewAdd = new WebView("views/customView", "viewInfo") ;
    var htmlView = window.currentView.htmlOrig.trim() ;
    while(htmlView.indexOf("<script") === 0 || htmlView.indexOf("<style") === 0){
        if(htmlView.indexOf("<script") === 0){
            var indexEnd = htmlView.indexOf("</script>") ;
            indexEnd = htmlView.indexOf(">", indexEnd)+1 ;
            htmlView = htmlView.substring(indexEnd).trim() ;
        }else if(htmlView.indexOf("<style") === 0){
            var indexEnd = htmlView.indexOf("</style>") ;
            indexEnd = htmlView.indexOf(">", indexEnd)+1 ;
            htmlView = htmlView.substring(indexEnd).trim() ;
        }
    }
    var viewData = JSON.parse(JSON.stringify(window.currentView.getBoundObject())) ;
    var templateController = new TemplateController() ;
    if(viewData.results){
        viewData.results = viewData.results.map(function(r){
            r =  JSON.parse(JSON.stringify(r)) ;
            templateController.formatForTemplate(window.currentView.table, r) ;
            return r;
        }) ;
    }else{
        templateController.formatForTemplate(window.currentView.table, viewData) ;
    }
    viewAdd.openInPopup({
        data: {
            viewPath: window.currentView.directory+"/"+window.currentView.name,
            htmlOrig: htmlView,
            dataStr: JSON.stringify(viewData, null, 2),
            table: window.currentView.table
        },
        size: "wide"
    })  ;
} ;

mainController.onMenuLogo = function(){
    var modulesRights = Object.keys(window.app.context.api.currentUser.rights).filter(function(r){return /module_user$/.test(r) ;}) ;
    if(modulesRights.length === 1 && modulesRights[0] === "group_iz_dinvoice_customer_user"){
        window.app.navigate("/dinvoice-main") ;
    }else{
        window.app.navigate("/dashboard") ;
    }
} ;


var searchTimeoutId = null;
var lastSearch = 0;
mainController.onGlobalSearch = function(ev){
    var globalSearchValue = this.view.EL.globalSearch.value ;
    if(lastSearch === globalSearchValue){ return ; }
    lastSearch = globalSearchValue ;

    if(searchTimeoutId){
        clearTimeout(searchTimeoutId) ;
    }
    if(globalSearchValue){
        if(!this.data.globalSearchRunning){
            this.data.globalSearchRunning = true ;
            this.data.globalSearchResults = [];
            this.renderingCount = true;
            this.view.render() ;
            this.renderingCount = false;
        }
        var $globalSearchResults = $(this.view.getElement(this.view.EL.globalSearchResults));
        var $globalSearchClose = $(this.view.getElement(this.view.EL.globalSearchClose));
        $globalSearchClose.removeClass("visibility-hidden") ;
        $globalSearchResults.addClass("d-block") ;
        $globalSearchResults.removeClass("d-none") ;
        setTimeout(function(){
            $globalSearchResults.addClass("show") ;
        }.bind(this),1);
    }else{
        var $globalSearchResults = $(this.view.getElement(this.view.EL.globalSearchResults));
        var $globalSearchClose = $(this.view.getElement(this.view.EL.globalSearchClose));
        $globalSearchResults.removeClass("show") ;
        $globalSearchClose.addClass("visibility-hidden") ;
        setTimeout(function(){
            $globalSearchResults.addClass("d-none") ;
            $globalSearchResults.removeClass("d-block") ;
        }, 500);
        this.data.globalSearchRunning = false ;
        this.data.globalSearchResults = [];
        this.renderingCount = true;
        this.view.render() ;
        this.renderingCount = false;
        return;
    }

    searchTimeoutId = setTimeout(function(){
        var globalSearches = [] ;
        window.APP_MODULES.forEach(function(module){
            if(module.globalSearches){
                globalSearches = globalSearches.concat(module.globalSearches) ;
            }
        }) ;
        globalSearches = globalSearches.filter(function(e){
            if(!e.rights){ return true ;}
            var rights = e.rights.split(/\s/).map(function(w){
                if(w === "&&" || w === "||" || w === "(" || w === ")"|| w === "!"){ return w ;}
                if(w.startsWith("!")){
                    return "!user.rights."+w.replace("!", "") ;
                }else{
                    return "user.rights."+w ;
                }
            }).join(" ") ;
            return new Function("user", "return "+rights)(this.api.currentUser||{rights:{}}) ;
        }.bind(this)) ;

        var promises = [] ;
        this.data.globalSearchResults = [];
        globalSearches.forEach(function(globalSearch, i){
            var search = { 
                $or : globalSearch.searchFields.map(function(f){
                    var field = f;
                    var fieldSearch = "%"+globalSearchValue+"%" ;
                    if(/^startwith:/i.test(field)){
                        fieldSearch = globalSearchValue+"%" ;
                        field = field.replace(/^startwith:/i, "") ;
                    }
                    var s = {};
                    s[field] = fieldSearch;
                    return s;
                }) 
            } ;
            if(globalSearch.searchFilter && Object.keys(globalSearch.searchFilter).length>0){
                search = {
                    $and: [
                        globalSearch.searchFilter,
                        search
                    ]
                } ;
            } 

            var searches = {} ;

            searches["search"+i] = {
                table: globalSearch.table,
                search: search,
                orderBy: globalSearch.orderBy || "id desc",
                joinFetch: globalSearch.joins,
                limit: 5
            } ;

            promises.push(new Promise(function(resolve, reject){
                var doSearch = function(){
                    this.api.db.multiread(searches, function(err, reads){
                        if(err){ return reject(err) ; }
                        if(lastSearch !== globalSearchValue){ return resolve() ;}
                        var blockResults = {
                            title: globalSearch.title,
                            icon: globalSearch.icon,
                            color: globalSearch.color,
                            results: []
                        };
                        var searchResults = reads["search"+i] ;
                        var templateLabel = Handlebars.compile(globalSearch.labelField) ;
                        var templateSubLabel = Handlebars.compile(globalSearch.subLabelField||"") ;
                        var templateUrl = Handlebars.compile(globalSearch.url) ;
                        searchResults.forEach(function(result){
                            blockResults.results.push({
                                icon: globalSearch.icon,
                                color: globalSearch.color,
                                label: templateLabel(result),
                                subLabel: templateSubLabel(result),
                                url: templateUrl(result)
                            }) ;
                        }.bind(this)) ;
                        if(blockResults.results.length > 0){
                            this.data.globalSearchResults.push(blockResults) ;
                            this.renderingCount = true;
                            this.view.render() ;
                            this.renderingCount = false;
                        }
                        resolve() ;
                    }.bind(this)) ;
                }.bind(this) ;
                if(i%3 === 0){
                    setTimeout(doSearch, 10) ;
                }else{
                    doSearch() ;
                }
            }.bind(this)));
        }.bind(this)) ;

        Promise.all(promises).then(function(){
            this.data.globalSearchRunning = false ;
            this.renderingCount = true;
            this.view.render() ;
            this.renderingCount = false;
        }.bind(this)).catch(function(err){
            this.data.globalSearchRunning = false ;
            this.renderingCount = true;
            this.view.render() ;
            this.renderingCount = false;
            WebView.error(err) ;
        }.bind(this)) ;
    }.bind(this), 200) ;
} ;


/* 
The main controller is special, it should never been hidden because it contains others views 
So we change the default stack/unstack behaviour to "do nothing"
*/
mainController.stack = function(){} ;
mainController.unstack = function(){} ;

module.exports = mainController ;
